import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValoreAssoluto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 13" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-13",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "matrice",
				transform: "translate(222.222222, 277.777778)",
				children: [/* @__PURE__ */ _jsx("rect", {
					id: "Rectangle-Copy-17",
					stroke: "#0056C1",
					strokeWidth: 28,
					x: 180.666667,
					y: 69.5555556,
					width: 194.222222,
					height: 305.333333
				}), /* @__PURE__ */ _jsx("path", {
					d: "M34,449 L34,0 L0,0 L0,449 L34,449 Z M545,449 L545,0 L511,0 L511,449 L545,449 Z",
					id: "||",
					fill: "#424548",
					fillRule: "nonzero"
				})]
			})]
		})
	})]
});
export default SvgValoreAssoluto;
